module.exports = __webpack_public_path__ + "static/media/star_icn_landing_card_3.64fb1ade.svg";